import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    useSelector,
    useDispatch
} from 'react-redux';

import styles from './defaultHeader.module.css';
import logoImage from '../../assets/images/logo.png';
import SimpleLink from '../UI/Buttons/SimpleLink/SimpleLink';
import BubbleButton from '../UI/Buttons/BubbleButton/BubbleButton';
import LanguageSwitch from '../UI/LanguageSwitch/LanguageSwitch';
import userAvatarPlaceholder from '../../assets/images/other/user_avatar_placeholder.png';
import { logoutUser } from '../../app/features/userSlice';
import { setShowLogoutButton } from '../../app/features/headerUISlice';

function DefaultHeader() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const user = useSelector((state) => state.user.user);
    const [isOpenDropdown, setIsOpenDropdown] = useState(false);
    const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false);
    const [favTalents, setFavTalents] = useState([]);

    let displayName = '';
    let menuItems = <>
        <SimpleLink href="https://findcv.com/">{t('defaultHeader.home')}</SimpleLink>
        <SimpleLink href="https://findcv.com/for-employers/">{t('defaultHeader.for_employers')}</SimpleLink>
        <SimpleLink href="https://findcv.com/for-jobseekers/">{t('defaultHeader.for_job_seekers')}</SimpleLink>
        <SimpleLink href="https://findcv.com/about/">{t('defaultHeader.about')}</SimpleLink>
    </>;


    let triggerClass = styles.trigger;
    let mobileMenuClass = styles.mobile_menu;

    if (isOpenMobileMenu) {
        triggerClass += ` ${styles.trigger_open}`;
        mobileMenuClass += ` ${styles.mobile_menu_open}`;
    }

    if (user) {

        if (user.account_type === 'employer') {

            if (user.employer_status === 'business') {
                displayName = user.company_name;
            }
            else {
                displayName = user.first_name + ' ' + user.last_name;
            }

        }
        else {
            displayName = user.first_name + ' ' + user.last_name;
        }

    }

    const toggleDropdown = () => {
        setIsOpenDropdown(!isOpenDropdown);
        window.scrollTo(0, 0);
    }

    const handleMobileMenu = () => {
        if (isOpenMobileMenu) {
            window.scrollTo(0, 0);
        }
        setIsOpenMobileMenu(!isOpenMobileMenu);
    }

    const handleLogout = () => {
        // if (window?.FB?.logout) {
        //     window.FB.logout(() => { });
        // }

        localStorage.removeItem('activeStep',);
        localStorage.removeItem('formData',);
        dispatch(logoutUser());
        dispatch(setShowLogoutButton(false));
        navigate('/login');
    }

    return (
        <header className={styles.header}>
            <div className="fcv-content">
                <div className="fcv-row">
                    <div className={styles.col}>
                        <a href="https://findcv.com">
                            <img src={logoImage} alt="FindCV logo" />
                        </a>
                    </div>
                    <div className={styles.col}  >
                        <nav>{menuItems}</nav>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.buttons}>
                            {!user ? (
                                <>
                                    <BubbleButton to="/jobs" headerButton>{t('defaultHeader.find_jobs')}</BubbleButton>
                                    <BubbleButton to="/employer-portal" dark headerDarkButton>{t('defaultHeader.post_a_jobs')}</BubbleButton>
                                </>
                            ) : (
                                <>
                                    {user.account_type === 'employer' ? (
                                        <>
                                            {/* <BubbleButton to="/profile/my-jobs" headerButton>{t('defaultHeader.my_jobs')}</BubbleButton> */}
                                            {/* https://findcv.com/employer-portal/jobs */}
                                            <BubbleButton to="/employer-portal/jobs" headerButton>{t('defaultHeader.my_jobs')}</BubbleButton>
                                            <BubbleButton to="/employer-portal/create-job" dark headerDarkButton>{t('defaultHeader.post_a_jobs')}</BubbleButton>
                                            <BubbleButton to="/chat" headerButton style={{ justifyContent: "center", alignItems: 'center', display: "flex" }}>{
                                                <img src={require('../../assets/images/chatIcon.png')} className={styles.chatIcon} style={{ filter: 'invert(42%) sepia(43%) saturate(512%) hue-rotate(167deg)' }} />
                                            }</BubbleButton>
                                        </>
                                    ) : (
                                        <>
                                            <BubbleButton to="/jobs/saved" headerButton>{t('defaultHeader.saved_jobs')}</BubbleButton>
                                            <BubbleButton to="/jobs" dark headerDarkButton>{t('defaultHeader.find_jobs')}</BubbleButton>
                                            <BubbleButton to="/chat" headerButton style={{ justifyContent: "center", alignItems: 'center', display: "flex" }}>{
                                                <img src={require('../../assets/images/chatIcon.png')} className={styles.chatIcon} style={{ filter: 'invert(42%) sepia(43%) saturate(512%) hue-rotate(167deg)' }} />
                                            }</BubbleButton>
                                        </>
                                    )}
                                </>

                            )}


                        </div>
                        {user ? (
                            <>
                                <div style={{ display: "flex", width: '100%', justifyContent: "flex-start", alignItems: "flex-start", width: 'auto' }}>
                                    <LanguageSwitch />
                                </div>
                                {/* <div>
                                    {/* <MessageIcon   /> */}
                                {/* </div> */}
                                <div className={styles.header_user}>
                                    <div className={`${styles.header_user_main} ${isOpenDropdown ? styles.open : ''}`} onClick={toggleDropdown}>
                                        {user.profile_image ? (
                                            <img src={process.env.REACT_APP_UPLOADS_PATH + user.profile_image} alt="User avatar"
                                                onError={(e) => {
                                                    e.target.onerror = null; // Prevent infinite loop
                                                    e.target.src = userAvatarPlaceholder; // Set fallback image
                                                }}
                                            />
                                        ) : (
                                            <img src={userAvatarPlaceholder} alt="User avatar" />
                                        )}
                                    </div>
                                    <div
                                        // className={`${styles.header_user_drop} ${isOpenDropdown ? styles.open : ''}`}
                                        className={`${styles.header_user_drop} ${isOpenDropdown ? styles.open : ''} ${user.account_type === 'employer' ? styles.employer : styles.nonEmployer
                                            }`}
                                    >
                                        <div className={styles.profileSection}>
                                            <div className={styles.profileImageContainer}>
                                                {user.profile_image ? (
                                                    <img src={process.env.REACT_APP_UPLOADS_PATH + user.profile_image} alt="User avatar" 
                                                    onError={(e) => {
                                                        e.target.onerror = null; // Prevent infinite loop
                                                        e.target.src = userAvatarPlaceholder; // Set fallback image
                                                    }}/>
                                                ) : (
                                                    <img src={userAvatarPlaceholder} alt="User avatar" />
                                                )}
                                            </div>
                                            <div className={styles.profileData}>
                                                <div style={{ color: 'black', fontWeight: '600', textTransform: 'capitalize' }}>
                                                    {displayName.length > 10 ? `${displayName.substring(0, 10)}` : displayName}
                                                </div>
                                                <div>
                                                    {user.email}
                                                </div>
                                            </div>
                                        </div>
                                        <SimpleLink className={styles.headerLink} onClick={toggleDropdown} to={`/profile`}>{t('defaultHeader.profile')}</SimpleLink>
                                        <SimpleLink className={styles.headerLink} onClick={toggleDropdown} to="/profile/settings">{t('defaultHeader.settings')}</SimpleLink>
                                        {(user.account_type === 'employer') ? (
                                            <SimpleLink className={styles.headerLink} onClick={toggleDropdown} to="/profile/billing">{t('defaultHeader.billing')}</SimpleLink>
                                        ) : (
                                            <>
                                                <SimpleLink className={styles.headerLink} onClick={toggleDropdown} to="/profile/billing">{t('defaultHeader.billing')}</SimpleLink>
                                                <SimpleLink className={styles.headerLink} onClick={toggleDropdown} to="/profile/insights">{t('profile_insights')}</SimpleLink>
                                            </>
                                        )
                                        }
                                        {(user.account_type === 'employer') &&
                                            <>
                                                <SimpleLink
                                                    to="/jobseekers/saved"
                                                    className={`${styles.headerLink} saved-job-seekers`}
                                                    onClick={() => {
                                                        toggleDropdown()
                                                    }}
                                                >{t('saved_job_seekers')}</SimpleLink>
                                                <SimpleLink
                                                    to="/employer-portal"
                                                    className={`${styles.headerLink} saved-job-seekers`}
                                                    onClick={() => {
                                                        toggleDropdown()
                                                    }}
                                                >{t('forms.manage_job.employer_Portal')}</SimpleLink>
                                            </>
                                        }

                                        <div className={styles.profileSectionFooter}></div>

                                        <SimpleLink className={styles.headerLink} onClick={handleLogout}>{t('defaultHeader.logout')}</SimpleLink>

                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className={styles.signUpButtonWrapper} >
                                <div style={{ display: "flex", width: '100%', justifyContent: "flex-start", alignItems: "flex-start", width: 'auto' }}>
                                    <LanguageSwitch />
                                </div>
                                <BubbleButton to="/login" headerButton>{t('defaultHeader.login')}</BubbleButton>
                                <BubbleButton to="/create-account" dark headerDarkButton>{t('defaultHeader.signup')}</BubbleButton>
                            </div>
                        )}

                        <div className={triggerClass} onClick={handleMobileMenu}>
                            <i></i><i></i><i></i>
                        </div>
                        <div className={mobileMenuClass}>
                            {menuItems}
                            {!user && (
                                <>
                                    <SimpleLink onClick={handleMobileMenu} to="/employer-portal">{t('defaultHeader.post_a_jobs')}</SimpleLink>
                                    <SimpleLink onClick={handleMobileMenu} to="/jobs" dark>{t('defaultHeader.find_jobs')}</SimpleLink>
                                </>
                            )}
                            {user && (
                                <>
                                    {(user.account_type === 'employer') && (
                                        <>
                                            <SimpleLink onClick={handleMobileMenu} to="/employer-portal">{t('defaultHeader.post_a_jobs')}</SimpleLink>
                                            <SimpleLink onClick={handleMobileMenu} to="/profile/my-jobs" dark>{t('defaultHeader.my_jobs')}</SimpleLink>
                                        </>
                                    )}
                                    {(user.account_type === 'jobseeker') && (
                                        <>
                                            <SimpleLink onClick={handleMobileMenu} to="/jobs/saved">{t('defaultHeader.saved_jobs')}</SimpleLink>
                                            <SimpleLink onClick={handleMobileMenu} to="/jobs" dark>{t('defaultHeader.find_jobs')}</SimpleLink>
                                        </>
                                    )}

                                    <SimpleLink onClick={handleMobileMenu} to={`/profile`}>{t('defaultHeader.profile')}</SimpleLink>
                                    <SimpleLink onClick={handleMobileMenu} to="/profile/settings">{t('defaultHeader.settings')}</SimpleLink>
                                    {(user.account_type === 'employer') && (
                                        <SimpleLink onClick={handleMobileMenu} to="/profile/billing">{t('defaultHeader.subscription')}</SimpleLink>
                                    )}
                                    <SimpleLink onClick={() => {
                                        handleMobileMenu();
                                        handleLogout();
                                    }}>{t('defaultHeader.logout')}</SimpleLink>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default DefaultHeader;